// FORM LOADER
// ===========

class FormLoader {
    constructor(selector) {
        this.loader = document.querySelector(selector);
        this.response = this.loader.querySelector('.form-loader-response');
        this.loader.addEventListener('click', (e) => { this.onClick(e); });
    }

    error(response) {
        this.loader.classList.add('error');
        this.setResponse(response);
    }

    onClick(e) {
        if (e.target.nodeName !== 'A' && (this.loader.classList.contains('success') || this.loader.classList.contains('error'))) {
            this.reset();
        }
    }

    reset() {
        this.loader.classList.remove('show');
        this.loader.classList.remove('error');
        this.loader.classList.remove('success');
        this.setResponse('');
        if (this.form !== undefined) this.form.style.display = 'block';
    }

    show() {
        if (this.form !== undefined) this.form.style.display = 'none';
        this.loader.classList.add('show');
        this.loader.focus();
    }

    setResponse(response) {
        if (response !== undefined) {
            this.response.innerHTML = response;
        }
    }

    success(response) {
        this.loader.classList.add('success');
        this.setResponse(response);
    }
}

export default FormLoader;
